{
  "app.title": "Minitry",
  "auth.description.mock": "Mock-Anmeldemodus über die kanonische `apps/web/app/api`-Boundary.",
  "auth.description.real": "Kanonische Backend-Anmeldung über die generierten Verträge in `apps/web/app/api`.",
  "auth.email.label": "E-Mail",
  "auth.email.placeholder": "name@example.test",
  "auth.error.mock_unavailable": "Anmeldung im Mock-API-Modus ist derzeit nicht möglich.",
  "auth.error.real_unavailable": "Anmeldung gegen die kanonische Backend-API ist derzeit nicht möglich.",
  "auth.loading": "Anmeldedaten werden geladen...",
  "auth.mock.hint": "Keine Mock-Konten verfügbar. Gib die E-Mail manuell ein.",
  "auth.mock.use": "Verwenden",
  "auth.password.label": "Passwort",
  "auth.password.placeholder": "passwort",
  "auth.real.hint": "Der Real-API-Modus ist aktiv. Verwende E-Mail und Passwort eines Backend-Kontos.",
  "auth.submit": "Anmelden",
  "auth.submitting": "Anmeldung läuft...",
  "auth.title": "Anmelden",
  "auth.validation.credentials_required": "E-Mail und Passwort sind erforderlich.",
  "coffee.description": "Aggregate-Profile-Oberfläche für Kaffee-Events, Bereitschaft und gebundene Standardvorlagen über die kanonische `apps/web/app/api`-Grenze.",
  "coffee.details.checklists": "Checklisten",
  "coffee.details.completed": "Erledigt",
  "coffee.details.assignments": "Zuweisungen",
  "coffee.details.empty": "Für diese Sektion sind noch keine Coffee-Einträge vorhanden.",
  "coffee.details.pending": "Offen",
  "coffee.details.resources": "Ressourcenprüfungen",
  "coffee.details.responsibilities": "Verantwortlichkeiten",
  "coffee.details.slots": "Slots",
  "coffee.details.tasks": "Aufgaben",
  "coffee.events.active": "Aktiv",
  "coffee.events.create_description": "Erstelle ein neues Kaffee-Event getrennt von der laufenden Event-Liste.",
  "coffee.events.description": "Wähle ein Kaffee-Event aus, um die aktuelle Bereitschaftsprojektion und die gebundenen Arbeitssektionen zu sehen.",
  "coffee.events.empty": "Noch keine Kaffee-Events vorhanden.",
  "coffee.events.title": "Kaffee-Event-Auswahl",
  "coffee.navigation.events": "Kaffee-Events",
  "coffee.navigation.overview": "Überblick",
  "coffee.navigation.participants": "Teilnehmende",
  "coffee.navigation.readiness": "Bereitschaft",
  "coffee.navigation.sections": "Sektionen",
  "coffee.participants.current_event": "Aktuelles Kaffee-Event",
  "coffee.participants.description": "Diese Teilnehmenden sind direkt an das aktuell ausgewählte Kaffee-Event gebunden.",
  "coffee.participants.empty": "Sobald ein Kaffee-Event ausgewählt ist, erscheint hier die zugehörige Teilnehmendenliste.",
  "coffee.participants.none_assigned": "Für das aktuell ausgewählte Kaffee-Event sind noch keine Teilnehmenden gebunden.",
  "coffee.participants.title": "Teilnehmende",
  "coffee.role_status.title": "Meine Event-Rolle",
  "coffee.role_status.description": "Diese Statuskarte zeigt, wie du im aktuell ausgewählten Kaffee-Event eingeordnet bist.",
  "coffee.role_status.none": "Kein Event ausgewählt",
  "coffee.role_status.none_description": "Wähle ein Kaffee-Event aus, damit deine Rolle im Event aufgelöst werden kann.",
  "coffee.role_status.leader": "Leitende Person",
  "coffee.role_status.participant": "Teilnehmende Person",
  "coffee.role_status.observer": "Beobachtende Person",
  "coffee.assignments.assigned_by": "Zugewiesen von",
  "coffee.assignments.none_primary": "Noch keine Hauptbesetzung zugewiesen.",
  "coffee.assignments.none_reserve": "Noch keine Reserve zugewiesen.",
  "coffee.assignments.participant": "Teilnehmende Person",
  "coffee.assignments.primary": "Hauptbesetzung",
  "coffee.assignments.reserve": "Reserve",
  "coffee.assignments.role": "Rolle",
  "coffee.assignments.status": "Status",
  "coffee.assignments.availability": "Verfuegbarkeit",
  "coffee.assignments.fit": "Passung",
  "coffee.assignments.fit_match": "Coffee-Profil-Match",
  "coffee.assignments.fit_unmapped": "Kein Coffee-Profil-Match",
  "coffee.assignments.workload": "Auslastung",
  "coffee.assignments.workload_value": "{count} Slots",
  "coffee.responsibilities.note": "Notiz",
  "coffee.responsibilities.note_placeholder": "Hand-off oder Umsetzungsnotiz aktualisieren",
  "coffee.responsibilities.owner": "Verantwortliche Person",
  "coffee.responsibilities.owner_edit_ready": "Owner-Wechsel speichert den neuen `assigneeUserId` direkt auf der kanonischen Responsibility.",
  "coffee.responsibilities.owner_slot": "Owner-Slot",
  "coffee.responsibilities.phase": "Phase",
  "coffee.responsibilities.phase_unknown": "Unbekannte Phase",
  "coffee.workspace.back": "Zurueck zu Coffee",
  "coffee.workspace.description": "Dies ist die fokussierte Event-Arbeitsflaeche fuer leitende Personen. Hier bearbeitest du Event-Details, besetzt Slots, weist Verantwortlichkeiten zu und pflegst Notizen.",
  "coffee.workspace.event_description": "Aktualisiere hier die modifizierbaren Event-Felder fuer diesen Coffee-Termin.",
  "coffee.workspace.assignments_description": "Teilnehmende werden dem Event praktisch dadurch hinzugefuegt, dass sie Slots und Rollen zugewiesen bekommen.",
  "coffee.workspace.participants_description": "Diese Liste zeigt die verfuegbaren und bereits eingebundenen Personen fuer das aktuelle Coffee-Event.",
  "coffee.workspace.responsibilities_description": "Verantwortlichkeiten koennen hier einer Person zugewiesen, im Status angepasst und mit Notizen dokumentiert werden.",
  "coffee.workspace.no_slots": "Fuer dieses Coffee-Event sind noch keine Slots materialisiert.",
  "coffee.workspace.no_responsibilities": "Fuer dieses Coffee-Event sind noch keine Verantwortlichkeiten verfuegbar.",
  "coffee.workspace.not_assigned": "Noch nicht zugewiesen",
  "coffee.workspace.assignment_note": "Notiz",
  "coffee.workspace.assignment_note_placeholder": "Optionaler Kontext fuer die Zuweisung",
  "coffee.workspace.add_assignment": "Zuweisung speichern",
  "coffee.workspace.add_responsibility": "Verantwortlichkeit hinzufuegen",
  "coffee.workspace.add_responsibility_description": "Erstelle direkt in der kanonischen Event-Responsibility-Sammlung eine manuelle Verantwortlichkeit fuer dieses Coffee-Event.",
  "coffee.workspace.add_responsibility_placeholder": "Zum Beispiel eine zusaetzliche Ausgabestation vorbereiten",
  "coffee.workspace.update_responsibility": "Verantwortlichkeit aktualisieren",
  "coffee.workspace.save_responsibility": "Verantwortlichkeit speichern",
  "coffee.overview.description": "Diese Oberfläche bleibt innerhalb der ADR-Grenzen: Sie zeigt Modulmetadaten und eine Kaffee-Dashboard-Projektion, während operative Schreibpfade im funktionalen Core bleiben.",
  "coffee.overview.selected_event": "Aktives Kaffee-Event",
  "coffee.overview.title": "Kaffee-Dashboard",
  "coffee.readiness.description": "Blockierende Probleme: {blocking} · Warnungen: {warning}",
  "coffee.readiness.empty_description": "Sobald ein Kaffee-Event verfügbar ist, zeigt diese Oberfläche die Bereitschaftsprojektion über Slots, Assignments, Verantwortlichkeiten, Aufgaben, Checklisten und Ressourcenprüfungen.",
  "coffee.readiness.empty_summary": "Es ist noch kein Kaffee-Event ausgewählt.",
  "coffee.readiness.meta": "Projektion für Event {eventId}",
  "coffee.readiness.meta_empty": "Keine aktive Kaffee-Projektion geladen.",
  "coffee.readiness.summary": "Aktueller Kaffee-Status: {status}",
  "coffee.readiness.title": "Kaffee-Bereitschaft",
  "coffee.readiness.workflow_title": "Workflow-Bereitschaft",
  "coffee.readiness.workflow_description": "Folge dem Coffee-Ablauf von Staffing über Verantwortlichkeiten und Ausführung bis zur finalen Einsatzfreigabe.",
  "coffee.readiness.issue_title": "Bereitschaftsprobleme",
  "coffee.readiness.issue_empty": "Aktuell sind keine blockierenden oder warnenden Bereitschaftsprobleme offen.",
  "coffee.readiness.issue_description": "Blockierend: {blocking} · Warnend: {warning}",
  "coffee.readiness.jump_to_stage": "Zum Abschnitt",
  "coffee.readiness.issue.required_slot_missing_primary": "Mindestens ein erforderlicher Slot hat noch keine Hauptbesetzung.",
  "coffee.readiness.issue.slot_underfilled": "Ein Slot ist aktuell unterbesetzt.",
  "coffee.readiness.issue.slot_overfilled": "Ein Slot ist aktuell überbesetzt.",
  "coffee.readiness.issue.reserve_without_primary": "Für einen Slot gibt es Reserve ohne Hauptbesetzung.",
  "coffee.readiness.issue.primary_assignment_unconfirmed": "Mindestens eine Hauptbesetzung ist noch nicht bestätigt.",
  "coffee.readiness.issue.reserve_assignment_unconfirmed": "Mindestens eine Reserve-Zuweisung ist noch nicht bestätigt.",
  "coffee.readiness.issue.responsibility_unassigned": "Mindestens eine Verantwortung ist noch keiner Person zugeordnet.",
  "coffee.readiness.issue.responsibility_incomplete": "Mindestens eine Verantwortung ist noch nicht abgeschlossen.",
  "coffee.readiness.issue.task_unassigned": "Mindestens eine Aufgabe ist noch nicht zugeordnet.",
  "coffee.readiness.issue.task_incomplete": "Mindestens eine Aufgabe ist noch offen.",
  "coffee.readiness.issue.checklist_incomplete": "Mindestens ein Checklistenpunkt ist noch offen.",
  "coffee.readiness.issue.resource_not_checked": "Mindestens eine Ressourcenprüfung wurde noch nicht geprüft.",
  "coffee.readiness.issue.resource_missing": "Mindestens eine Ressource fehlt aktuell.",
  "coffee.readiness.issue.resource_low": "Mindestens eine Ressource ist knapp.",
  "coffee.workflow.staffing.title": "1. Staffing",
  "coffee.workflow.staffing.description": "Prüfe Coffee-Slots und stelle sicher, dass Haupt- und Reservebesetzung sinnvoll gesetzt sind.",
  "coffee.workflow.staffing.summary": "{count} Slots im Staffing-Ablauf",
  "coffee.workflow.responsibilities.title": "2. Verantwortlichkeiten",
  "coffee.workflow.responsibilities.description": "Arbeite die eventgebundenen Coffee-Verantwortlichkeiten mit Owner, Phase, Status und Notiz durch.",
  "coffee.workflow.responsibilities.summary": "{count} Verantwortlichkeiten im Ablauf",
  "coffee.workflow.execution.title": "3. Ausführung",
  "coffee.workflow.execution.description": "Halte Aufgaben und Checklisten synchron, damit das Team die operative Vorbereitung sauber abschließt.",
  "coffee.workflow.execution.summary": "{tasks} Aufgaben · {checklists} Checklisten",
  "coffee.workflow.resources.title": "4. Ressourcen",
  "coffee.workflow.resources.description": "Bestätige Bestände und Ressourcenstatus, bevor der Coffee-Dienst final freigegeben wird.",
  "coffee.workflow.resources.summary": "{count} Ressourcenprüfungen im Ablauf",
  "coffee.workflow.final.title": "5. Finaler Status",
  "coffee.workflow.final.description": "Die Abschlussansicht bündelt offene Probleme, erledigte Checks und den aktuellen operativen Zustand.",
  "coffee.workflow.final.open_issues": "Offene Probleme",
  "coffee.workflow.final.completed_checks": "Erledigte Checks",
  "coffee.workflow.final.resource_risks": "Ressourcenrisiken",
  "coffee.workflow.final.operational_state": "Operativer Zustand",
  "coffee.workflow.final.state_summary": "Abschlussstatus: {status}. Dieser Abschnitt bündelt die letzten offenen Punkte vor dem operativen Coffee-Handoff.",
  "coffee.workflow.final.no_open_issues": "Keine offenen Probleme mehr. Der Coffee-Ablauf ist aus Sicht der aktuellen Readiness-Projektion frei von Blockern und Warnungen.",
  "coffee.workflow.final.no_completed_checks": "Noch keine abgeschlossenen Checklistenpunkte im Closeout sichtbar.",
  "coffee.workflow.final.no_resource_risks": "Keine verbleibenden Ressourcenrisiken. Die Bestandslage ist fuer den Coffee-Abschluss aktuell stabil.",
  "coffee.reminders.title": "6. Erinnerungen",
  "coffee.reminders.description": "Bereite gezielte Reminder für offene Verantwortlichkeiten und Bestandsrisiken vor.",
  "coffee.reminders.responsibilities_title": "Reminder für Verantwortlichkeiten",
  "coffee.reminders.resources_title": "Reminder für Ressourcen",
  "coffee.reminders.none_responsibilities": "Aktuell brauchen keine offenen Verantwortlichkeiten einen Reminder.",
  "coffee.reminders.none_resources": "Aktuell brauchen keine Ressourcenprüfungen einen Reminder.",
  "coffee.reminders.target_leader": "Leader-Ziel",
  "coffee.reminders.target_assignee": "Verantwortliche Person",
  "coffee.reminders.target_unassigned": "Noch keine verantwortliche Person",
  "coffee.reminders.leader_action": "Leader erinnern",
  "coffee.reminders.assignee_action": "Verantwortliche Person erinnern",
  "coffee.reminders.contract_ready": "Reminder laufen jetzt über den kanonischen Event-Reminder-Contract und nutzen standardmäßig die bevorzugten Benachrichtigungskanäle.",
  "coffee.notifications.title": "Benachrichtigungen",
  "coffee.notifications.description": "Hier werden event-spezifische Benachrichtigungen für das ausgewählte Coffee-Event gesammelt: Reminder, Statusänderungen und weitere Einträge aus dem kanonischen Notification-Feed.",
  "coffee.notifications.back_to_workspace": "Zurueck zum Workspace",
  "coffee.notifications.open_workspace": "Workspace öffnen",
  "coffee.notifications.disabled": "Für dieses Event ist die Notifications-Capability derzeit nicht aktiviert.",
  "coffee.notifications.empty": "Für dieses Event gibt es noch keine Benachrichtigungen.",
  "coffee.notifications.channels": "Kanäle",
  "coffee.notifications.created_at": "Erstellt",
  "coffee.notifications.sent_at": "Gesendet",
  "coffee.notifications.read_at": "Gelesen",
  "coffee.notifications.not_sent": "noch nicht gesendet",
  "coffee.notifications.unread": "noch nicht gelesen",
  "coffee.notifications.open_link": "Link öffnen",
  "coffee.actions.mark_complete": "Als erledigt markieren",
  "coffee.actions.reopen": "Wieder öffnen",
  "coffee.actions.update": "Aktualisieren",
  "coffee.details.unassigned": "nicht zugewiesen",
  "coffee.error.update_failed": "Die Coffee-Änderung konnte gerade nicht gespeichert werden.",
  "coffee.sections.description": "Die Zähler zeigen, welche Coffee-gebundenen Kernsektionen in der aktuellen Projektion verfügbar sind.",
  "coffee.sections.disabled": "Für dieses Event deaktiviert",
  "coffee.sections.empty": "Es sind noch keine Coffee-Sektionen verfügbar.",
  "coffee.sections.enabled": "Aktiv in der Projektion",
  "coffee.sections.title": "Sektionsabdeckung",
  "coffee.slots.capacity": "Kapazitaet",
  "coffee.slots.add_description": "Erstelle einen Custom-Slot fuer zusaetzliche Teilnehmende im Coffee-Team.",
  "coffee.slots.add_title": "Slot hinzufuegen",
  "coffee.slots.code": "Slot-Code",
  "coffee.slots.code_placeholder": "z. B. backup_barista",
  "coffee.slots.custom": "Custom",
  "coffee.slots.delete": "Slot loeschen",
  "coffee.slots.display_name": "Slot-Name",
  "coffee.slots.display_name_placeholder": "Zum Beispiel Backup Barista",
  "coffee.slots.is_required": "Slot ist erforderlich",
  "coffee.slots.locked_hint": "Bei Slots mit Zuweisungen bleiben rule-kritische Felder schreibgeschuetzt.",
  "coffee.slots.materialized": "Blueprint",
  "coffee.slots.max_quantity": "Maximum",
  "coffee.slots.min_quantity": "Minimum",
  "coffee.slots.optional": "Optional",
  "coffee.slots.required": "Erforderlich",
  "coffee.slots.save": "Slot speichern",
  "coffee.slots.update": "Slot aktualisieren",
  "coffee.title": "Kaffeedienst",
  "music.assignments.participant": "Teilnehmende Person",
  "music.assignments.primary": "Primaer",
  "music.assignments.reserve": "Reserve",
  "music.assignments.role": "Rolle",
  "music.description": "Das Musikmodul bündelt Event-Planung, Slot-Zuweisungen und Repertoire für das Worship-Team.",
  "music.details.assignments": "Zuweisungen",
  "music.events.active": "Aktiv",
  "music.events.create_description": "Erstelle Service- und Rehearsal-Events für das Musikteam.",
  "music.events.description": "Wähle ein Musik-Event aus, um dessen Workspace mit Repertoire und Slots zu öffnen.",
  "music.events.title": "Musik-Events",
  "music.notifications.title": "Benachrichtigungen",
  "music.participants.description": "Hier erscheinen Teilnehmende mit Musik-Zuweisungen und ihrer Availability.",
  "music.participants.empty": "Für das Musikmodul sind noch keine Teilnehmenden vorhanden.",
  "music.participants.none_assigned": "Für dieses Musik-Event gibt es noch keine Zuweisungen.",
  "music.participants.title": "Teilnehmende",
  "music.repertoire.artist_unknown": "Unbekannter Artist",
  "music.repertoire.description": "Die aktuelle Setlist des Events auf Basis der kanonischen Repertoire-API.",
  "music.repertoire.empty": "Für dieses Event wurde noch kein Repertoire ausgewählt.",
  "music.repertoire.key_unknown": "Unbekannte Tonart",
  "music.repertoire.kind.primary": "Primaer",
  "music.repertoire.kind.reserve": "Reserve",
  "music.repertoire.title": "Repertoire",
  "music.role_status.description": "Zeigt an, ob du Musikleiter, per Slot eingebundene Person oder nur Beobachter für das aktuelle Event bist.",
  "music.role_status.leader": "Musikleitung",
  "music.role_status.none": "Kein Event ausgewählt",
  "music.role_status.observer": "Beobachter",
  "music.role_status.participant": "Musik-Teilnehmende",
  "music.role_status.title": "Dein Musikstatus",
  "music.notes.title": "Event-Notizen",
  "music.notes.description": "Hier sammeln wir Notizen, die fuer das Music-Event bereits vom Backend kommen.",
  "music.notes.empty": "Das Backend hat fuer dieses Musik-Event noch keine Notizen geliefert.",
  "music.notes.kind.assignment": "Zuweisung",
  "music.notes.kind.attendance": "Teilnahme",
  "music.notes.kind.checklist": "Checkliste",
  "music.notes.kind.repertoire": "Repertoire",
  "music.notes.kind.task": "Aufgabe",
  "music.error.update_failed": "Die Music-Aenderung konnte gerade nicht gespeichert werden.",
  "music.slots.add_description": "Erstelle einen Custom-Slot fuer zusaetzliche Teilnehmende im Music-Team.",
  "music.slots.add_title": "Slot hinzufuegen",
  "music.slots.custom": "Custom",
  "music.slots.delete": "Slot loeschen",
  "music.slots.display_name": "Slot-Name",
  "music.slots.display_name_placeholder": "Zum Beispiel Choir support",
  "music.slots.is_required": "Slot ist erforderlich",
  "music.slots.locked_hint": "Bei Slots mit Zuweisungen bleiben rule-kritische Felder schreibgeschuetzt.",
  "music.slots.materialized": "Blueprint",
  "music.slots.max_quantity": "Maximum",
  "music.slots.min_quantity": "Minimum",
  "music.slots.optional": "Optional",
  "music.slots.required": "Erforderlich",
  "music.slots.save": "Slot speichern",
  "music.slots.update": "Slot aktualisieren",
  "music.title": "Musikdienst",
  "music.workspace.add_assignment": "Zuweisung speichern",
  "music.workspace.assignment_note": "Notiz",
  "music.workspace.assignment_note_placeholder": "Zum Beispiel einen Übergang ohne Klick vorbereiten.",
  "music.workspace.assignments_description": "Verwalte Worship-Slots und Zuweisungen direkt im Music-Workspace.",
  "music.workspace.back": "Zurueck zu Musik",
  "music.workspace.event_description": "Aktualisiere die Details des Musik-Events direkt im profilgebundenen Workspace.",
  "music.workspace.no_slots": "Für dieses Musik-Event sind noch keine Slots materialisiert.",
  "music.workspace.not_assigned": "Nicht zugewiesen",
  "music.workspace.participants_description": "Sieh alle Personen des Music-Workspace zusammen mit Rollen und Availability.",
  "coffee.status.blocked": "blockiert",
  "coffee.status.cancelled": "abgebrochen",
  "coffee.status.done": "erledigt",
  "coffee.status.in_progress": "in Arbeit",
  "coffee.status.low": "niedrig",
  "coffee.status.missing": "fehlt",
  "coffee.status.not_applicable": "nicht zutreffend",
  "coffee.status.not_checked": "nicht geprueft",
  "coffee.status.planned": "geplant",
  "coffee.status.ready": "bereit",
  "coffee.status.todo": "offen",
  "error.400.subtitle": "Wenn du denkst, dass das System hier falsch liegt, gib uns bitte Bescheid.",
  "error.400.title": "400 – Die Anfrage ist ungültig.",
  "error.403.subtitle": "Diese Oberfläche ist aktuell nur für Admin-Nutzer freigegeben.",
  "error.403.title": "403 – Zugriff verweigert.",
  "error.404.subtitle": "\"{pathname}\" ist keine verfügbare Seite.",
  "error.404.title": "404 – Diese Seite wurde nicht gefunden.",
  "error.500.subtitle": "\"{pathname}\" ist derzeit nicht verfügbar.",
  "error.500.title": "500 – Etwas ist schiefgelaufen.",
  "error.go_home": "Zur Startseite",
  "error.noscript": "Diese Anwendung funktioniert deutlich besser mit aktiviertem JavaScript.",
  "errors.auth.authentication_required": "Für diese Aktion ist eine Anmeldung erforderlich.",
  "errors.auth.invalid_api_token": "Das Zugriffstoken ist ungültig oder abgelaufen.",
  "errors.auth.invalid_authorization_header": "Der Authorization-Header ist ungültig.",
  "errors.auth.invalid_credentials": "E-Mail oder Passwort sind ungültig.",
  "errors.auth.invalid_refresh_token": "Das Aktualisierungstoken ist ungültig oder wurde widerrufen.",
  "errors.auth.rate_limited.login": "Zu viele Anmeldeversuche. Bitte versuche es später erneut.",
  "errors.request.invalid_payload": "Die Anfrage ist ungültig.",
  "errors.users.locale_unsupported": "Diese Sprache wird für Benutzerprofile nicht unterstützt.",
  "home.navigation.coffee": "Kaffee",
  "home.navigation.admin": "Admin",
  "home.navigation.music": "Musik",
  "home.navigation.events": "Veranstaltungen",
  "home.navigation.features": "Features",
  "home.navigation.home": "Start",
  "home.navigation.members": "Mitglieder",
  "home.navigation.notifications": "Benachrichtigungen",
  "home.navigation.profile": "Profil",
  "home.navigation.timeline": "Zeitleiste",
  "home.section.events": "Veranstaltungen",
  "events.actions.edit": "Bearbeiten",
  "events.actions.cancel": "Abbrechen",
  "events.actions.update": "Event aktualisieren",
  "events.create.description": "Lege neue Events direkt über die kanonische Events-API an.",
  "events.create.submit": "Event erstellen",
  "events.create.submitting": "Event wird erstellt...",
  "events.create.title": "Neues Event",
  "events.description": "Diese Oberfläche liest Veranstaltungen aus dem funktionalen Core und erlaubt jetzt Erstellen sowie Bearbeiten über die kanonischen Event-Endpunkte.",
  "events.edit.description": "Aktualisiere die vertraglich unterstützten Event-Felder des ausgewählten Events.",
  "events.edit.empty": "Wähle links ein Event aus, um dessen Daten zu bearbeiten.",
  "events.edit.submit": "Event speichern",
  "events.edit.submitting": "Event wird gespeichert...",
  "events.edit.title": "Ausgewähltes Event",
  "events.error.save_failed": "Das Event konnte gerade nicht gespeichert werden.",
  "events.chat.compose": "Neue Nachricht",
  "events.chat.delete": "Nachricht löschen",
  "events.chat.deleting": "Nachricht wird gelöscht...",
  "events.chat.description": "Arbeite direkt mit den kanonischen Chat-Nachrichten des ausgewählten Events.",
  "events.chat.disabled": "Chat ist für dieses Eventprofil nicht aktiviert.",
  "events.chat.edit": "Nachricht bearbeiten",
  "events.chat.empty": "Sobald ein Event ausgewählt ist, erscheint hier dessen kanonischer Event-Chat.",
  "events.chat.list_empty": "Für dieses Event gibt es noch keine Chat-Nachrichten.",
  "events.chat.pinned": "Angeheftet",
  "events.chat.placeholder": "Teile eine kurze Nachricht für das Event-Team...",
  "events.chat.submit": "Nachricht senden",
  "events.chat.submitting": "Nachricht wird gesendet...",
  "events.chat.title": "Event-Chat",
  "events.chat.update": "Nachricht speichern",
  "events.chat.updating": "Nachricht wird gespeichert...",
  "events.field.aggregate_profile": "Aggregatprofil",
  "events.field.blueprint_version": "Blueprint-Version",
  "events.field.ends_at": "Ende",
  "events.field.event_type": "Event-Typ",
  "events.field.group": "Gruppe",
  "events.field.leader": "Leitende Person",
  "events.field.location": "Ort",
  "events.field.scope": "Event-Bereich",
  "events.field.starts_at": "Beginn",
  "events.field.status": "Status",
  "events.field.title": "Titel",
  "events.participants.title": "Teilnehmende",
  "events.participants.description": "Filtere die relevanten Personen nach zugewiesener Rolle, Verfügbarkeit und bei Bedarf nach Ministry-Kontext.",
  "events.participants.empty": "Keine Teilnehmenden passen aktuell zu den gesetzten Filtern.",
  "events.participants.filters.availability": "Verfuegbarkeit",
  "events.participants.filters.all_availability": "Alle Verfuegbarkeiten",
  "events.participants.filters.no_availability": "Keine Verfuegbarkeit",
  "events.participants.filters.ministry": "Ministry",
  "events.participants.filters.all_ministries": "Alle Ministries",
  "events.participants.filters.role": "Zugewiesene Rolle",
  "events.participants.filters.all_roles": "Alle zugewiesenen Rollen",
  "events.participants.meta.availability": "Verfuegbarkeit",
  "events.participants.meta.assignment_role": "Zugewiesene Rolle",
  "events.participants.meta.no_ministry": "Keine Ministry-Zuordnung",
  "events.participants.meta.primary": "Hauptbesetzung",
  "events.participants.meta.reserve": "Reserve",
  "events.role_status.title": "Meine Event-Rolle",
  "events.role_status.description": "Diese Statuskarte zeigt, wie du im aktuell ausgewählten Event eingeordnet bist.",
  "events.role_status.none": "Kein Event ausgewählt",
  "events.role_status.none_description": "Wähle ein Event aus, damit deine Rolle im Event aufgelöst werden kann.",
  "events.role_status.leader": "Leitende Person",
  "events.role_status.participant": "Teilnehmende Person",
  "events.role_status.observer": "Beobachtende Person",
  "events.role_status.account_role": "Kontorolle",
  "events.list.title": "Event-Liste",
  "events.list.scoped_summary": "{count} laufende Events im Profil {profile}",
  "events.notice.created": "Das Event wurde erstellt.",
  "events.notice.assignment_created": "Die Zuweisung wurde gespeichert.",
  "events.notice.assignment_updated": "Die Zuweisung wurde aktualisiert.",
  "events.notice.updated": "Das Event wurde aktualisiert.",
  "events.option.cancelled": "Abgebrochen",
  "events.option.coffee": "Kaffee",
  "events.option.completed": "Abgeschlossen",
  "events.option.confirmation_in_progress": "Bestaetigung laeuft",
  "events.option.confirmed": "Bestaetigt",
  "events.option.draft": "Entwurf",
  "events.option.kids": "Kinder",
  "events.option.media": "Medien",
  "events.option.meeting": "Treffen",
  "events.option.music": "Musik",
  "events.option.needs_attention": "Benötigt Aufmerksamkeit",
  "events.option.leaders": "Leitende",
  "events.option.participants": "Teilnehmende",
  "events.option.profile_wide": "Profilweit",
  "events.option.published": "Veröffentlicht",
  "events.option.rehearsal": "Probe",
  "events.option.service": "Gottesdienst",
  "events.option.simple": "Einfach",
  "events.option.structured": "Strukturiert",
  "events.option.group_scoped": "Gruppenbezogen",
  "events.assignment_status.awaiting_response": "Wartet auf Antwort",
  "events.assignment_status.cancelled": "Abgebrochen",
  "events.assignment_status.confirmed": "Bestätigt",
  "events.assignment_status.declined": "Abgelehnt",
  "events.assignment_status.expired": "Abgelaufen",
  "events.assignment_status.planned": "Geplant",
  "events.assignment_status.replaced": "Ersetzt",
  "events.assignment_role.primary": "Primaer",
  "events.assignment_role.reserve": "Reserve",
  "events.assignment_action.cancel": "Zuweisung aufheben",
  "events.assignment_action.confirm": "Bestaetigen",
  "events.assignment_action.decline": "Ablehnen",
  "events.group.none_available": "Keine Gruppen verfügbar",
  "events.scope.group_scoped": "Gruppenbezogen",
  "events.scope.group_scoped_description": "Dieses Event nutzt eine konkrete Gruppe innerhalb des gewählten Aggregatprofils.",
  "events.scope.profile_wide": "Profilweit",
  "events.scope.profile_wide_description": "Dieses Event gilt für das gewählte Aggregatprofil insgesamt und ist keiner einzelnen Gruppe zugeordnet.",
  "events.placeholder.location": "Haupthalle",
  "events.placeholder.title": "Sonntagsgottesdienst",
  "events.readiness.blocking": "Blockierend",
  "events.readiness.capabilities": "Ausgewertete Fähigkeiten",
  "events.readiness.description": "Der ausgewählte Event lädt den kanonischen Bereitschaftsbericht aus dem Events-Core.",
  "events.readiness.empty": "Sobald ein Event ausgewählt ist, wird hier der kanonische Bereitschaftsbericht angezeigt.",
  "events.readiness.issues": "Bereitschaftsprobleme",
  "events.readiness.no_issues": "Für dieses Event wurden aktuell keine Bereitschaftsprobleme gemeldet.",
  "events.readiness.none": "Noch nichts ausgewertet",
  "events.readiness.title": "Bereitschaftsbericht",
  "events.readiness.warning": "Warnungen",
  "events.validation.invalid_payload": "Bitte prüfe die Event-Felder und versuche es erneut.",
  "events.polls.already_voted": "Deine Stimme wurde für diese Umfrage bereits erfasst.",
  "events.polls.close": "Umfrage schließen",
  "events.polls.closes_at": "Schließt am",
  "events.polls.closing": "Umfrage wird geschlossen...",
  "events.polls.create": "Umfrage erstellen",
  "events.polls.creating": "Umfrage wird erstellt...",
  "events.polls.delete": "Umfrage löschen",
  "events.polls.deleting": "Umfrage wird gelöscht...",
  "events.polls.description": "Arbeite direkt mit den kanonischen Polls des ausgewählten Events.",
  "events.polls.disabled": "Polls sind für dieses Eventprofil nicht aktiviert.",
  "events.polls.edit": "Umfrage bearbeiten",
  "events.polls.empty": "Sobald ein Event ausgewählt ist, erscheinen hier dessen kanonische Polls.",
  "events.polls.list_empty": "Für dieses Event gibt es noch keine Polls.",
  "events.polls.multiple_choice": "Mehrfachauswahl erlauben",
  "events.polls.option_four": "Option 4",
  "events.polls.option_one": "Option 1",
  "events.polls.option_three": "Option 3",
  "events.polls.option_two": "Option 2",
  "events.polls.pinned": "Angeheftet",
  "events.polls.question": "Frage",
  "events.polls.question_placeholder": "Wer kann nach dem Event beim Abbau helfen?",
  "events.polls.status.closed": "Geschlossen",
  "events.polls.status.deleted": "Gelöscht",
  "events.polls.status.open": "Offen",
  "events.polls.title": "Event-Polls",
  "events.polls.update": "Umfrage speichern",
  "events.polls.updating": "Umfrage wird gespeichert...",
  "events.polls.visibility": "Sichtbarkeit",
  "events.polls.vote": "Stimme abgeben",
  "events.polls.voting": "Stimme wird gespeichert...",
  "events.attendance.action.mark_status": "Als {status} markieren",
  "events.attendance.add": "Teilnahme hinzufügen",
  "events.attendance.description": "Nutze die kanonischen Teilnahmen, um Personen einzuladen, Teilnahme zu markieren und Simple-Profile-Events zu unterstützen.",
  "events.attendance.empty": "Für dieses Event wurden noch keine Teilnahmen angelegt.",
  "events.attendance.add_selected": "Ausgewählte Teilnahmen anlegen",
  "events.attendance.field.initial_status": "Startstatus",
  "events.attendance.field.kind": "Teilnahmeart",
  "events.attendance.field.participant": "Teilnehmende Person",
  "events.attendance.flow.assignment_and_attendance": "Dieses Event unterstützt sowohl Event-Teilnahmen als auch slot-basierte Zuweisungen.",
  "events.attendance.flow.attendance_only": "Dieses Event nutzt Teilnahme als primären Teilnehmerfluss.",
  "events.attendance.kind.attendee": "Teilnehmend",
  "events.attendance.kind.audience": "Publikum",
  "events.attendance.kind.guest": "Gast",
  "events.attendance.kind.listener": "Zuhörend",
  "events.attendance.kind.other": "Sonstiges",
  "events.attendance.kind.regular_attendee": "Regelmäßige teilnehmende Person",
  "events.attendance.kind.visitor": "Besucher/in",
  "events.attendance.none_available": "Keine verfügbaren Teilnehmenden",
  "events.attendance.remove": "Entfernen",
  "events.attendance.save_status": "Teilnahmestatus speichern",
  "events.attendance.select_all": "Alle auswählen",
  "events.attendance.selected_empty": "Wähle links mehrere Personen aus, um sie gesammelt anzulegen.",
  "events.attendance.selected_title": "Ausgewählte Teilnehmende ({count})",
  "events.attendance.selection_help": "Wähle mehrere Personen aus. Teilnahmeart und Startstatus werden beim Auswählen übernommen und können pro Person vor dem Speichern angepasst werden.",
  "events.attendance.deselect_all": "Alle abwählen",
  "events.attendance.slots_disabled": "Slots sind für dieses Profil nicht aktiviert, daher erfolgt die Teilnehmerverwaltung unten über Teilnahmen.",
  "events.attendance.source.assignment": "Zuweisung",
  "events.attendance.source.group": "Gruppe",
  "events.attendance.source.import": "Import",
  "events.attendance.source.manual": "Manuell",
  "events.attendance.source.registration": "Registrierung",
  "events.attendance.status.attended": "Anwesend gewesen",
  "events.attendance.status.cancelled": "Abgesagt",
  "events.attendance.status.declined": "Abgelehnt",
  "events.attendance.status.going": "Zugesagt",
  "events.attendance.status.invited": "Eingeladen",
  "events.attendance.title": "Event-Teilnahmen",
  "events.workspace.assignments": "Zuordnungen",
  "events.workspace.capabilities": "Workspace-Fähigkeiten",
  "events.workspace.description": "Diese Projektion zeigt die kanonische Workspace-Zusammenfassung des ausgewählten Events.",
  "events.workspace.empty": "Sobald ein Event ausgewählt ist, erscheint hier dessen Workspace-Projektion.",
  "events.workspace.slots": "Slots",
  "events.workspace.timeline": "Zeitleiste",
  "events.workspace.timeline_empty": "Für dieses Event sind noch keine Timeline-Einträge vorhanden.",
  "events.workspace.title": "Event-Workspace",
  "home.section.members": "Mitglieder",
  "home.welcome": "Willkommen zurück, {name}",
  "admin.title": "Administration",
  "admin.description": "Diese Route bündelt die heute im Frontend vorhandenen Admin-Einstiegspunkte und bleibt auf Backend-verfügbare Fähigkeiten beschränkt.",
  "admin.meta.current_role": "Aktuelle Rolle",
  "admin.meta.api_mode": "API-Modus",
  "admin.overview.title": "Überblick",
  "admin.overview.description": "Schnelle Kennzahlen aus den bereits verfügbaren Event- und Benutzer-Payloads.",
  "admin.overview.empty": "Es sind noch keine Events verfügbar.",
  "admin.metric.events_total": "Events gesamt",
  "admin.metric.events_published": "Veröffentlichte Events",
  "admin.metric.events_draft": "Entwurfs-Events",
  "admin.metric.participants_known": "Bekannte Teilnehmende",
  "admin.metric.coffee_events": "Kaffee-Events",
  "admin.workflows.title": "Verfügbare Admin-Workflows",
  "admin.workflows.description": "Diese Verknüpfungen führen zu den bereits implementierten Verwaltungsoberflächen im Frontend.",
  "admin.workflows.events_title": "Events verwalten",
  "admin.workflows.events_description": "Erstelle und bearbeite Events, filtere nach Status und prüfe die bekannten Teilnehmenden.",
  "admin.workflows.open_events": "Events öffnen",
  "admin.workflows.coffee_title": "Kaffee-Modul prüfen",
  "admin.workflows.coffee_description": "Öffne die Coffee-Oberfläche für modulgebundene Status- und Bereitschaftsabläufe.",
  "admin.workflows.open_coffee": "Kaffee öffnen",
  "admin.workflows.profile_title": "Eigenes Profil verwalten",
  "admin.workflows.profile_description": "Prüfe die aktuell im Frontend unterstützten Benutzer- und Sprachpräferenzen.",
  "admin.workflows.open_profile": "Profil öffnen",
  "navigation.mobile.collapse": "Navigation schließen",
  "navigation.mobile.expand": "Navigation öffnen",
  "planning.current_session": "Aktuelle API-Sitzung",
  "planning.event_badge.count": "Kanonische Events: {count}",
  "planning.event_badge.empty": "Noch keine kanonischen Events",
  "planning.loading": "Workspace wird geladen...",
  "planning.no_events": "Noch keine kanonischen Events vorhanden.",
  "planning.no_members": "Noch keine Mitglieder gefunden.",
  "planning.session.description": "Du bist über den {mode}-API-Modus angemeldet. Diese Route bleibt durch den Root-Session-Guard geschützt und liest kanonische Daten über `apps/web/app/api` statt über direkte Mock-Verkabelung.",
  "planning.sign_out": "Abmelden",
  "planning.workspace_timeline": "Workspace-Zeitleiste",
  "planning.workspace_timeline.empty": "Für den aktuellen Event-Workspace sind noch keine kanonischen Timeline-Einträge verfügbar.",
  "profile.account.description": "Bearbeite nur Felder, die bereits durch den kanonischen `Users`-Vertrag unterstützt werden.",
  "profile.account.title": "Kontodaten",
  "profile.back_home": "Zur Workspace-Startseite",
  "profile.channel.email": "E-Mail",
  "profile.channel.push": "Push",
  "profile.channel.telegram": "Telegram",
  "profile.description": "Diese Route bleibt innerhalb der ADR-Grenzen: Lesen und Schreiben laufen ausschließlich über `GET/PATCH /users/me`, während aggregate profile separat bleiben.",
  "profile.empty.description": "Es konnte kein aktuelles Benutzerprofil geladen werden.",
  "profile.error.save_failed": "Das Profil konnte gerade nicht gespeichert werden.",
  "profile.field.display_name": "Anzeigename",
  "profile.field.email": "E-Mail",
  "profile.field.locale": "Sprache",
  "profile.field.notifications": "Benachrichtigungen",
  "profile.field.notifications_enabled": "Benachrichtigungen aktivieren",
  "profile.field.role": "Rolle",
  "profile.form.note": "Gruppen, Instrumente und Spezialisierungen bleiben vorerst schreibgeschützt, bis es dafür eigene kanonische Lookup-Flows gibt.",
  "profile.locale.de": "Deutsch",
  "profile.locale.ru": "Russisch",
  "profile.meta.api_mode": "API-Modus: {mode}",
  "profile.meta.locale": "Sprache: {locale}",
  "profile.meta.title": "Kanonische Metadaten",
  "profile.meta.user_id": "Benutzer-ID",
  "profile.notifications.description": "Die Präferenzen werden als Teil des funktionalen `Users`-Core gespeichert und nicht in ministry-spezifischen Profilen.",
  "notifications.index.title": "Event-Benachrichtigungen",
  "notifications.index.description": "Hier kannst du für {name} die Benachrichtigungen eines konkreten Events öffnen.",
  "notifications.index.events_title": "Events",
  "notifications.index.events_description": "Wähle ein Event aus, um dessen event-spezifischen Notification-Feed zu öffnen.",
  "notifications.index.empty": "Es sind noch keine Events für Benachrichtigungen verfügbar.",
  "notifications.index.open_event": "Event-Benachrichtigungen öffnen",
  "notifications.event.title": "Event-Benachrichtigungen",
  "notifications.event.back": "Zurueck zur Benachrichtigungsliste",
  "notifications.event.open_workspace": "Workspace öffnen",
  "notifications.event.disabled": "Für dieses Event ist die Notifications-Capability derzeit nicht aktiviert.",
  "notifications.event.empty": "Für dieses Event gibt es noch keine Benachrichtigungen.",
  "notifications.event.channels": "Kanäle",
  "notifications.event.created_at": "Erstellt",
  "notifications.event.sent_at": "Gesendet",
  "notifications.event.read_at": "Gelesen",
  "notifications.event.not_sent": "noch nicht gesendet",
  "notifications.event.unread": "noch nicht gelesen",
  "notifications.event.open_link": "Link öffnen",
  "features.title": "Feature-Übersicht nach Modulen",
  "features.description": "Hier siehst du, welche Fähigkeiten der Event-Module für {name} bereits umgesetzt sind und welche noch nicht angebunden wurden.",
  "features.status.implemented": "implementiert",
  "features.status.not_implemented": "nicht implementiert",
  "profile.preferences.description": "Locale und Benachrichtigungskanäle werden über die Route-Aktion aktualisiert und mit dem Backend-Vertrag synchronisiert.",
  "profile.preferences.title": "Präferenzen",
  "profile.read_only.description": "Diese Felder stammen direkt aus dem kanonischen User-Payload. Die Route erfindet dafür keine zusätzlichen Lookup-Modelle.",
  "profile.read_only.empty.groups": "Noch keine Gruppen hinterlegt.",
  "profile.read_only.empty.instruments": "Noch keine Instrumente hinterlegt.",
  "profile.read_only.empty.specializations": "Noch keine Spezialisierungen hinterlegt.",
  "profile.read_only.group_ids": "Gruppen-IDs",
  "profile.read_only.instrument_ids": "Instrument-IDs",
  "profile.read_only.specializations": "Spezialisierungen",
  "profile.read_only.title": "Schreibgeschützte Vertragsfelder",
  "profile.saved": "Das Profil wurde gespeichert.",
  "profile.state.empty.description": "Diese Oberfläche erwartet einen authentifizierten Benutzer aus dem funktionalen `Users`-Core.",
  "profile.state.empty.summary": "Kein Profil verfügbar.",
  "profile.state.error.description": "Die Route bleibt funktionsfähig, aber die letzte Speicheraktion hat kein erfolgreiches Backend-Ergebnis geliefert.",
  "profile.state.error.summary": "Die Profiländerungen konnten nicht übernommen werden.",
  "profile.state.loading.description": "Die Route wartet auf das kanonische `users/me`-Payload.",
  "profile.state.loading.summary": "Benutzerprofil wird geladen...",
  "profile.state.meta": "Aktiver API-Modus: {mode}",
  "profile.state.ready.description": "Schreibzugriffe laufen über die Route-Aktion und `PATCH /users/me`, ohne profile-spezifische Nebenpfade einzuführen.",
  "profile.state.ready.summary": "Benutzerprofil und Präferenzen sind verfügbar.",
  "profile.state.title": "Profilstatus",
  "profile.submit": "Profil speichern",
  "profile.submitting": "Profil wird gespeichert...",
  "profile.title": "Benutzerprofil",
  "profile.validation.display_name_required": "Der Anzeigename ist erforderlich.",
  "errors.polls.vote_already_recorded": "Deine Stimme für diese Umfrage wurde bereits erfasst.",
  "errors.capability.not_enabled": "Diese Funktion ist für dieses Eventprofil nicht aktiviert.",
  "errors.validation.min_items": "Bitte gib mindestens zwei Optionen an.",
  "shared.language.de": "DE",
  "shared.language.label": "Sprache",
  "shared.language.ru": "RU",
  "events": {
    "admin": {
      "empty": "Wähle ein Event aus, um die Admin-Arbeitsfläche zu öffnen.",
      "forbidden": "Diese Admin-Funktion ist für deine aktuelle Rolle oder dieses Event nicht verfügbar.",
      "read_only": "Diese Sektion ist für deine aktuelle Rolle schreibgeschützt.",
      "assignments": {
        "title": "Assignment-Verwaltung",
        "description": "Verwalte Slot-Besetzungen, prüfe Kandidaten und aktualisiere Assignment-Status direkt im Event-Workspace.",
        "empty": "Für dieses Event sind noch keine Slots verfügbar.",
        "no_candidates": "Für diesen Slot sind aktuell keine planbaren Kandidaten verfügbar.",
        "none": "Für diesen Slot gibt es noch keine Assignments.",
        "optional": "Optional",
        "required": "Erforderlich",
        "create": "Assignment anlegen",
        "update": "Status speichern",
        "capacity": "Min {min} · Max {max}"
      },
      "availability": {
        "title": "Teilnehmer-Verfügbarkeit",
        "description": "Prüfe die kanonische Verfügbarkeit von Kandidaten und bereits eingeplanten Personen.",
        "empty": "Für diese Person liegen aktuell keine Verfügbarkeitszeiträume vor.",
        "none_selected": "Wähle oben eine Person aus, um ihre Verfügbarkeit zu sehen."
      },
      "repertoire": {
        "title": "Repertoire-Verwaltung",
        "description": "Pflege den Event-Repertoire-Stand über den kanonischen Songkatalog und die Event-Repertoire-Schnittstelle.",
        "no_tags": "Keine Tags",
        "primary": "Primary",
        "reserve": "Reserve",
        "unavailable": "Für dieses Event ist keine Repertoire-Funktion aktiviert.",
        "unknown_artist": "Unbekannte:r Interpret:in",
        "update": "Repertoire speichern",
        "version": "Version"
      }
    },
    "assignment_role": {
      "primary": "Primary",
      "reserve": "Reserve"
    },
    "assignment_status": {
      "planned": "Geplant",
      "awaiting_response": "Wartet auf Rückmeldung",
      "confirmed": "Bestätigt",
      "declined": "Abgelehnt",
      "expired": "Abgelaufen",
      "replaced": "Ersetzt",
      "cancelled": "Abgebrochen"
    },
    "availability_kind": {
      "unavailable": "Nicht verfügbar",
      "busy": "Beschäftigt",
      "preferred": "Bevorzugt verfügbar"
    },
    "create": {
      "short": "Neues Event erstellen"
    },
    "filters": {
      "status": "Status filtern",
      "all_statuses": "Alle Status"
    },
    "participants": {
      "title": "Teilnehmende",
      "description": "Alle bekannten Teilnehmenden mit Filtern nach Verfügbarkeit und Dienstbereich.",
      "empty": "Keine Teilnehmenden passen zu den aktuellen Filtern.",
      "filters": {
        "availability": "Verfügbarkeit",
        "all_availability": "Alle Verfügbarkeiten",
        "no_availability": "Keine Verfügbarkeit hinterlegt",
        "ministry": "Dienstbereich",
        "all_ministries": "Alle Dienstbereiche"
      },
      "meta": {
        "ministries": "Dienstbereiche",
        "no_ministry": "Nicht zugeordnet",
        "availability": "Verfügbarkeit"
      },
      "event": {
        "empty": "Für dieses Event sind aktuell keine passenden Teilnehmenden verfügbar.",
        "assign_after_create": "Teilnehmende werden slotbasiert zugewiesen.",
        "assign_after_create_description": "Sobald das Event erstellt wurde, kannst du Teilnehmende ueber die kanonische Assignments-API mit Event- und Slot-ID zuweisen.",
        "assignment_based": "Teilnehmende werden ueber Slot-Zuweisungen des Events verwaltet.",
        "add_label": "Teilnehmende hinzufügen",
        "add": "Hinzufügen",
        "available_title": "Verfuegbare Teilnehmende",
        "any_type": "Für dieses nicht gruppierte Event können Teilnehmende aller Typen ausgewählt werden.",
        "ministry_scoped": "Für dieses Event werden bevorzugt passende Teilnehmende aus dem Dienstbereich angezeigt.",
        "none_available": "Keine weiteren Teilnehmenden verfügbar",
        "none_selected": "Diesem Event sind aktuell noch keine Teilnehmenden hinzugefügt.",
        "no_slots": "Für dieses Event sind aktuell noch keine zuweisbaren Slots vorhanden.",
        "remove": "Entfernen",
        "select_hint": "Auswählen und abwählen in dieser Liste fügt Teilnehmende hinzu oder entfernt sie wieder.",
        "temporary_select_hint": "Diese Auswahl bleibt vorerst im Frontend sichtbar, bis dem Event zuweisbare Slots zur Verfuegung stehen.",
        "selected_count": "Ausgewählt: {count}"
      },
      "slot": {
        "add": "Teilnehmende fuer diesen Slot",
        "assign": "Teilnehmende zuweisen",
        "capacity": "Min {min} · Max {max}",
        "no_candidates": "Für diesen Slot sind aktuell keine planbaren Kandidaten verfügbar.",
        "none_assigned": "Diesem Slot ist aktuell noch niemand zugewiesen.",
        "required": "Erforderlich",
        "role": "Zuweisungsrolle",
        "unlimited": "offen"
      }
    },
    "field": {
      "participants": "Teilnehmende"
    }
  }
}
